<mat-toolbar color="primary">
    <a [routerLink]="['/']" class="toolbar-link">
        <span>cicd.kubevirt-manager.io</span>
    </a>
</mat-toolbar>
  
<div class="main-content-container">
    <div class="left-panel">
        <mat-card>
          <mat-card-header>
            <mat-card-title>
              {{this.pipelineId}}
              &nbsp;
              <button mat-icon-button (click)="viewPipelineYaml(this.pipelineId)"><mat-icon>code</mat-icon></button>
              <a mat-icon-button href="/assets/{{this.pipelineId}}/" target="_blank"><mat-icon>attach_file</mat-icon></a>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <mat-list>
              <mat-list-item *ngFor="let task of this.taskList">
                <span class="task-status">
                    <mat-icon *ngIf="task.statusCode === '1'"class="status-error">error</mat-icon>
                    <mat-icon *ngIf="task.statusCode === '0'"class="status-success">check_circle</mat-icon>
                    <span class="task-name">&nbsp; {{ task.taskName }} &nbsp;</span>
                    <button mat-icon-button (click)="viewTaskLog(this.pipelineId, task.taskName)"><mat-icon>description</mat-icon></button>
                    <button mat-icon-button (click)="viewTaskYaml(this.pipelineId, task.taskName)"><mat-icon>code</mat-icon></button>
                </span>
              </mat-list-item>
            </mat-list>
          </mat-card-content>
        </mat-card>
    </div>
  
    <div class="right-panel">
      <mat-card>
        <mat-card-header>
          <mat-card-title>Details</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div *ngIf="currentView === 'log'">
                <app-log-viewer [logContent]="selectedTaskLog"></app-log-viewer>
            </div>
            <div *ngIf="currentView === 'yaml'">
                <app-yaml-viewer [yamlContent]="selectedTaskYaml"></app-yaml-viewer>
            </div>
        </mat-card-content>
      </mat-card>
    </div>
</div>

  <div class="footer-copyright">
    <div>
        Licensed under <a href="https://www.apache.org/licenses/LICENSE-2.0.html" style="font-weight:bold;">Apache License 2.0.</a>
    </div>
    <div>
        Copyright © 2022-2025 <span style="font-weight:bold;">KubeVirt Manager</span>.
    </div>
    <div>
        All rights reserved.
    </div>
  </div>
